import queryString from 'query-string'

export const buildAssetUrlString = (path) => {
  const host = window.asset_host || ''

  return queryString.stringifyUrl({
    url: `${host}${path}`,
  })
}
